export const NewInboardTableDetails = [
    { head: "Warehouse Count", value: 80 },
    { head: "Scheduled Appointment", value: 690 },
    { head: "Problematic Site", value: 5 },
    { head: "Expected On-Time Arrivals", value: 5 },
    { head: "Delays Expected", value: 3 },
  ];